<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="dedication">
<h1>Dedication</h1>
<blockquote>
<p style="text-align: center;">This book is for my grandchildren in the hope that only by examining history they can appreciate the unknown of the future.</p>
</blockquote>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch002.vue?553435c2